function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#A6A6B4",
  d: "M-246-167h1440v339H-246z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M5.19 10.437h7.62V14H5.19v-3.563zm8.965 1.114V9.324H3.845v2.227H2.5V7.01c0-.936.76-1.695 1.696-1.695h9.608c.937 0 1.696.759 1.696 1.695v4.54h-1.345zm-.896-3.563a.67.67 0 0 0 .672-.668.67.67 0 0 0-.672-.668.67.67 0 0 0-.673.668.67.67 0 0 0 .673.668zM5.326 3h7.913v1.158H5.326V3z"
}));

var SvgFax = function SvgFax(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFax, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fax.047b88bd.svg";
export { ForwardRef as ReactComponent };